function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48 80c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32z",
  fill: "#45A74C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.265 27.013c-11.59.407-20.659 10.133-20.252 21.722.407 11.59 10.133 20.659 21.722 20.252 11.59-.407 20.659-10.133 20.252-21.722-.407-11.59-10.133-20.659-21.722-20.252z",
  fill: "#DDEAC5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M60.973 50.693c-.293 2.453-1.427 4.933-3.533 6.186-.107.067-.787.413-.907.48a.1.1 0 01-.133-.133c.053-.12.44-.427.56-.72.653-1.547.186-3.334-.907-4.334-1.253-1.146-3.347-1.293-4.853-.48a4.248 4.248 0 00-2.134 4.48c.32 1.854 1.814 2.934 4.08 2.92.054 0 .08.067.027.094-1.387.947-6.093 1.08-9.133.72-2.907-.347-5.734-1.213-8.52-2.133-.227-.08-.574-.214-.574-.427 0-.12.16-.347.227-.453a21.086 21.086 0 002.027-5.494c.666-3.013.706-6.28 2.333-8.92 2.613-4.213 8.387-5.44 12.507-3.013.733.426 1.36 1.267 1.946 1.933.067.08.2.067.24-.04a22.303 22.303 0 001.787-6.547 6.75 6.75 0 013.307 1.974 26.543 26.543 0 00-4.027 5.466c-.067.107.013.24.133.267 1.76.214 3.374 1.307 4.36 2.8 1.054 1.56 1.4 3.52 1.187 5.373z",
  fill: "#45A74C"
});

var SvgAppiconFortune = function SvgAppiconFortune(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconFortune, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-fortune.4b4a5320.svg";
export { ForwardRef as ReactComponent };